import { useCallback } from 'react';
import { useGuide } from '@knocklabs/react';
import { useGetMeApiWithSessionContext } from 'eds-common/api/v2';

const WELCOME_GUIDE_KEY = 'welcome-modal';

export function useWelcomeGuide() {
  const { step } = useGuide({ key: WELCOME_GUIDE_KEY });
  const { data: meResponse, isPending: isSessionPending } =
    useGetMeApiWithSessionContext();

  const isImpersonated = Boolean(meResponse?.isImpersonated);

  const markAsSeen = useCallback(() => {
    if (isImpersonated) {
      return;
    }

    step?.markAsSeen();
  }, [isImpersonated, step]);

  const markAsArchived = useCallback(() => {
    if (isImpersonated) {
      return;
    }

    step?.markAsArchived();
  }, [isImpersonated, step]);

  return { step, isSessionPending, markAsSeen, markAsArchived };
}
